module.exports = __webpack_public_path__ + "media/newstyle/images/icon-chevron_left-orange-3da1f463b5ca8fa81766d1aacf8fcf82.svg";